import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { DefaultGUID, MaxMinutesUnderHour } from 'src/app/@shared/constants/Constant';
import { IAcceptOrRejectLegAssignmentPayLoad, ILegDetailsViewModel } from 'src/app/model/Vendor.model';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import { AssignLeg, DropOffAddress } from 'src/app/service/assignLeg.model';
import { SpecialInstruction } from 'src/app/service/itinerary.model';
import { ItineraryService } from 'src/app/service/itinerary.service';
import { LocationService } from 'src/app/service/location.service';
import { MemberService } from 'src/app/service/member.service';
import { IGetMemberViewModel } from 'src/app/service/memeber.model';
import { IAirportCodeList, IVehicleResponseModel } from 'src/app/service/vehicle.model';
import { VehicleService } from 'src/app/service/vehicle.service';
import { VendorDashboardService } from 'src/app/service/vendor-dashboard.service';
import { VendorService } from 'src/app/service/vendor.service';

@Component({
  selector: 'app-assign-driver-dialog',
  templateUrl: './assign-reject-dialog.component.html',
  styleUrls: ['./assign-reject-dialog.component.css']
})
export class AssignRejectDialogComponent implements OnInit {

  private _subscriptions: Subscription = new Subscription();
  assignLegPayload: AssignLeg = {
    organizationType: 'External',
    selectedContactPerson: {
      memberId: DefaultGUID,
      role: '',
      addressId: DefaultGUID,
      streetAddress: '',
      name: '',
      address: '',
      phoneNumber: '',
      dateOfBirth: null,
      weight: 0,
      gender: '',
    },
    vendorId: '',
    legAssignmentIdList: [],
    contactId: '',
    createdBy: DefaultGUID,
    vehicleId: '',
    vehicleNumber: '',
    dropOffAddress: [],
    specialInstruction: [],
    ibEstimatedBlockHours: 0,
    ibEstimatedBlockMinutes: 0,
    ibReposition: '',
    obEstimatedBlockHours: 0,
    obEstimatedBlockMinutes: 0,
    obReposition: ''
  };
  contactConfig = {
    displayKey: 'name',
    search: true,
    placeholder: 'Select Member',
    height: '290px'
  };
  user: ILoggedInUserViewModel;
  selectedMember: any;
  loader: boolean = false;
  isForRejection: boolean = false;
  selectedPhoneNumber: string = null;
  rejectionReason: string = '';
  acceptOrRejectLegAssignmentPayLoad: IAcceptOrRejectLegAssignmentPayLoad;
  vendorMemberList: IGetMemberViewModel[] = [];
  vehicleDetailList: IVehicleResponseModel[] = [];
  vehicleLoader: boolean = false;
  phoneNumberLoader: boolean = false;
  memberLoader: boolean = false;
  airportCodeList: IAirportCodeList[] = [];
  selectedOBReposition: IAirportCodeList[] = [];
  selectedIBReposition: IAirportCodeList[] = [];
  airportCodeDropDownSettings = {
    singleSelection: true,
    idField: 'addressId',
    textField: 'airportCode',
    itemsShowLimit: 1,
    allowSearchFilter: true,
  };
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: { legDetailList: ILegDetailsViewModel[], header: string },
    private _memberService: MemberService, private _vehicleService: VehicleService,
    private _vendorService: VendorService, private _itineraryService: ItineraryService,
    private _vendorDashboardService: VendorDashboardService, private _toastr: ToastrService,
    private _locationService: LocationService,
  ) { }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.isForRejection = this.dialogData.header.includes('Reject');
    this.assignLegPayload = {
      contactId: '',
      createdBy: this.user.memberId,
      dropOffAddress: this.setDropOffAddress(this.dialogData.legDetailList),
      selectedContactPerson: {
        memberId: DefaultGUID,
        role: '',
        addressId: DefaultGUID,
        streetAddress: '',
        name: '',
        address: '',
        phoneNumber: '',
        dateOfBirth: null,
        weight: 0,
        gender: '',
      },
      organizationType: 'External',
      specialInstruction: this.setSpecialInstructions(this.dialogData.legDetailList),
      vehicleId: '',
      vehicleNumber: '',
      vendorId: this.user.businessUnitId,
      legAssignmentIdList: this.setLegAssignmentIdList(this.dialogData.legDetailList),
      ibEstimatedBlockHours: 0,
      ibEstimatedBlockMinutes: 0,
      ibReposition: '',
      obEstimatedBlockHours: 0,
      obEstimatedBlockMinutes: 0,
      obReposition: ''
    }
    this.assignLegPayload.dropOffAddress.push();
    this.getAllAirportCodeList();

    if (this._vendorService.memberListByBUId$.value.length > 0) {
      this.vendorMemberList = this._vendorService.memberListByBUId$.value;
    }
    else {
      this.getMemberList();
    }

    if (this._vehicleService.vehicleList$.value.length > 0) {
      this.vehicleDetailList = this._vehicleService.vehicleList$.value;
    }
    else {
      this.getVehicleList();
    }

  }

  private getMemberList() {
    this.memberLoader = true;
    this._subscriptions.add(this._vendorService.getMemberListByCustomerID(this.user.businessUnitId).subscribe((response) => {
      this.vendorMemberList = response;
      this.memberLoader = false;
    }, () => {
      this.memberLoader = false;
      this._toastr.warning('Something went wrong while getting member list! Please refresh the page.', 'Warning', { timeOut: 6000, positionClass: 'toast-top-center' });
    }));
  }
  private getVehicleList() {
    this.vehicleLoader = true;
    this._subscriptions.add(this._vehicleService.getVehicleDetail(this.user.businessUnitId, false, 'all', -1, 1, '')
      .subscribe((response) => {
        this.vehicleDetailList = response.vehicleViewModels;
        this.vehicleLoader = false;
      }, () => {
        this.vehicleLoader = false;
        this._toastr.warning('Something went wrong while getting vehicle list! Please refresh the page.', 'Warning', { timeOut: 6000, positionClass: 'toast-top-center' });
      }));
  }

  private setDropOffAddress(legDetailList: ILegDetailsViewModel[]): DropOffAddress[] {
    let dropOffAddress: DropOffAddress[] = [];
    legDetailList.forEach((legDetail) => {
      dropOffAddress.push({
        destinationId: legDetail.destinationId,
        destinationName: legDetail.destination,
        endTime: legDetail.plannedDropOffDateTime,
        legId: legDetail.legId,
        originId: legDetail.originId,
        originName: legDetail.origin,
        startTime: legDetail.plannedPickUpDateTime,
        isLightsAndSirens: legDetail.isLightsAndSirens,
        flag: null
      });
    });
    return dropOffAddress;
  }

  private setSpecialInstructions(legDetailList: ILegDetailsViewModel[]): SpecialInstruction[] {
    let specialInstructionList: SpecialInstruction[] = [];
    legDetailList.forEach((legDetail) => {
      if (legDetail.specialInstruction.length > 0) {
        specialInstructionList.concat(legDetail.specialInstruction);
      }
    });
    return specialInstructionList;
  }

  private setLegAssignmentIdList(legDetailList: ILegDetailsViewModel[]): string[] {
    let legAssignmentIdList: string[] = [];
    legDetailList.forEach((legDetail) => {
      legAssignmentIdList.push(legDetail.legAssignmentId);
    });
    return legAssignmentIdList;
  }

  getPhoneNumberByMemberId(memberId: string) {
    if (memberId) {
      this.assignLegPayload.selectedContactPerson.memberId = memberId;
      this._subscriptions.add(this._memberService.getPhoneNoListById(memberId).subscribe((response) => {
        this.phoneNumberLoader = false;
        if (response) {
          this.selectedPhoneNumber = response[0].phoneNumber;
          this.assignLegPayload.contactId = response[0].phoneId;
        }
        else {
          this.selectedPhoneNumber = null;
        }
      }, () => {
        this.phoneNumberLoader = false;
        this._toastr.warning('Something went wrong while getting phone number! Please try again', 'Warning', { timeOut: 6000, positionClass: 'toast-top-center' });
      }));
    }
  }

  selectVehicle(vehicleId: string) {
    const selectedVehicle: IVehicleResponseModel = this.vehicleDetailList.find(x => x.vehicleId == vehicleId);
    this.assignLegPayload.vehicleNumber = selectedVehicle.vehicleNumber;
    this.assignLegPayload.vehicleId = selectedVehicle.vehicleId;
  }

  assignDriver(event: any) {
    if (!event.form.valid) {
      return;
    }
    if (this.assignLegPayload.obEstimatedBlockMinutes < MaxMinutesUnderHour && this.assignLegPayload.ibEstimatedBlockMinutes < MaxMinutesUnderHour) {
      if (this.selectedOBReposition && this.selectedOBReposition.length > 0) this.assignLegPayload.obReposition = this.selectedOBReposition[0].airportCode;
      if (this.selectedIBReposition && this.selectedIBReposition.length > 0) this.assignLegPayload.ibReposition = this.selectedIBReposition[0].airportCode;
      this.loader = true;
      this._itineraryService.assignLeg(this.assignLegPayload).subscribe(
        () => {
          this.loader = false;
          this._itineraryService.$refreshLegDetails.next(null);
          this._vendorDashboardService.$resetSelectedLegDetailListFromLegDetailsService.next(null);
          this._toastr.success('Leg assigned successfully.', 'Success', { timeOut: 2000, positionClass: 'toast-top-center' });
        },
        () => {
          this.loader = false;
          this._toastr.warning('Something went wrong while assigning Leg!', 'Warning', { timeOut: 2000, positionClass: 'toast-top-center' });
        }
      );
    }
  }
  rejectAssignment(event: any) {
    if (event.form.valid) {
      let legIdList = [];
      this.dialogData.legDetailList.forEach((legDetails) => {
        legIdList.push(legDetails.legId);
      })
      this.acceptOrRejectLegAssignmentPayLoad = {
        isAccepted: false,
        legIdList: legIdList,
        updatedBy: this.user.memberId,
        vendorId: this.user.businessUnitId,
        rejectionReason: this.rejectionReason
      }

      this._subscriptions.add(this._vendorDashboardService.acceptOrRejectLegAssignmentRequest(this.acceptOrRejectLegAssignmentPayLoad).subscribe(() => {
        const msg = this.acceptOrRejectLegAssignmentPayLoad.legIdList.length > 1 ?
          "Request rejected successfully!" : "Selected requests rejected successfully!";
        this._toastr.success(msg, "Success",
          { timeOut: 6000, positionClass: "toast-top-center" });
        this._itineraryService.$refreshLegDetails.next(null);
        this._vendorDashboardService.$resetSelectedLegDetailListFromLegDetailsService.next(null);
      }, () => {
        this._toastr.warning("Something went wrong while rejecting the request!", "Warning",
          { timeOut: 6000, positionClass: "toast-top-center" });
      }));
    }
  }

  getAllAirportCodeList() {
    if (this._locationService.airportCodeList$.value.length > 0) {
      this.airportCodeList = this._locationService.airportCodeList$.value;
    }
    else {
      this._subscriptions.add(
        this._locationService.getAllAirportCodeList().subscribe(response => {
          this.airportCodeList = response;
        })
      );
    }
  }

}
